import * as React from "react";
import Modal, { IModalProps } from "../../../components/modal/modal";

export interface IAudioModalProps extends IModalProps {
    title: string;
    playerLink: string;
}

const AudioModal: React.FC<IAudioModalProps> = ({ playerLink, title, ...rest }) => {
    return (
        <Modal className="audio-modal" {...rest}>
            <div className="audio-player-wrapper">
                <h1 className="audio-player-title">{title}</h1>
                <audio controls>
                    <source src={playerLink} type="audio/mpeg" />
                </audio>
            </div>
        </Modal>
    );
};

export default AudioModal;
